export default "__VITE_ASSET__DUQn_3nM__"